<template>
  <div>
    <div class="bannerContent">
      <div class="bannerBox">
        <el-row>
          <el-col :span="5"
            ><div class="grid-content purple" @click="$router.push('/Home/pages')">天府再生资源云平台</div></el-col
          >
          <el-col :span="19"
            ><div class="grid-content routePurple">
            <span style="font-size: 20px" :key="index" :class="choseBannerPath == item.path?'choseBanner':''" v-for="(item,index) in pathArr" @click="chosePath(item.path)">{{item.name}}</span>
          </div></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="page-content">
      <router-view />
    </div>
    <bottom-url />
  </div>
</template>

<script>
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';

export default {
  name: 'index',
  components: {
    bottomUrl,
  },
  data() {
    return {
      registerVisible: false,
      pathArr: [
        {
          name: '价格上报',
          path: '/watePrice/priceReport',
        },
      ],
      choseBannerPath:'/watePrice/priceReport',
      userInfo:localStorage.getItem('ordinaryUser') ? JSON.parse(localStorage.getItem('ordinaryUser')) : null
    };
  },
  watch:{
    $route(to, from) {
      console.log('路由变化：', from.path, '→', to.path);
      this.choseBannerPath = to.path.match(/^(\/[^/]+\/[^/]+)/)[0];
    },
  },
  created() {},
  mounted() {
    this.choseBannerPath = this.$route.path
  },
  methods: {
    chosePath(path){
      this.choseBannerPath = path
      this.$router.push(path)
    }
  },
};
</script>

<style lang="less" scoped>
.bannerContent {
  height: 90px;
  display: flex;
  background: url("~@/assets/recycling/index/headerBGlogo.png") no-repeat center;
  background-size: cover;
  justify-content: center;
  .bannerBox {
    width: 1400px;
    height: 90px;
    line-height: 90px;
    .purple {
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 1px;
      color: #038F3B;
      cursor: pointer;
    }
  }
}
.routePurple {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 90px ;
  span{
    cursor: pointer;
    display: flex;
    padding: 10px 20px;
  }
}
.choseBanner {
  color: rgba(0, 0, 0, 1);
  font-weight: 700;
}
</style>
